// packages
import { geoPath } from 'd3-geo';
import Flatbush from 'flatbush';

// utils
import pointInPolygon from './point-in-polygon.js';

/**
 * @template G
 * @typedef {import('geojson').Feature<G>} Feature
 */

/**
 * @typedef {import('geojson').MultiPolygon} MultiPolygon
 * @typedef {import('geojson').Polygon} Polygon
 */

/**
 *
 * @param {Feature<Polygon | MultiPolygon>[]} features
 * @returns
 */
export default function createSearchIndex(features) {
  const path = geoPath();
  const count = features.length;

  // tell our Flatbush index how many to expect
  const index = new Flatbush(count);

  for (let idx = 0; idx < count; idx++) {
    const feature = features[idx];
    const bounds = path.bounds(feature);

    index.add(bounds[0][0], bounds[0][1], bounds[1][0], bounds[1][1]);
  }

  index.finish();

  return function findPolygon(/** @type {[number, number]} */ coords) {
    const found = index
      .search(coords[0], coords[1], coords[0], coords[1])
      .map((i) => features[i]);

    return found.find((feature) => pointInPolygon(coords, feature));
  };
}
